import './hospital.model';
export * from './hospital.service';
export * from './hospital.slice';
export * from './hospital.hooks';
